import { UseFormReset } from "react-hook-form";
import useUserInvStore, {
  IUserInvState,
} from "../../../common/components/user-inv-modal/api/store";
import {
  initialUserData,
  ModalType,
} from "../../../common/components/user-invitation-modal/api/types";
import useFacilityStore, { IUserManagementState } from "./store";
import {
  UserFormSchema,
  UserSchema,
} from "../../../common/components/user-inv-modal/api/schema";
import useUnsavedChangesDialogStore, {
  IUnsavedChangesDialogState,
} from "../../../common/components/unsaved-changes-dialog/api/store";
import useAccessibilityModalStore, {
  IAccessibilityModalState,
} from "../manage-access/store";

export class Handlers {
  private userManagementStore: IUserManagementState;
  private useUserInvStore: IUserInvState;
  private unsavedChangesDialogStore: IUnsavedChangesDialogState;
  private accessibilityModalState: IAccessibilityModalState;

  constructor() {
    this.userManagementStore = useFacilityStore.getState();
    this.useUserInvStore = useUserInvStore.getState();
    this.unsavedChangesDialogStore = useUnsavedChangesDialogStore.getState();
    this.accessibilityModalState = useAccessibilityModalStore.getState();
  }

  handleOpenUnsavedChangesDialogStore = () => {
    this.unsavedChangesDialogStore.setShowUnsavedChangesPrompt(true);
  };

  handleOpenAccessManagementModal = () => {
    //this.useUserInvStore.setSelectedUser(user);
    this.accessibilityModalState.setManageAccessModal(true);
  };

  handleCloseAccessManagementModal = () => {
    this.accessibilityModalState.setUserData(undefined);
    this.accessibilityModalState.setManageAccessModal(false);
  };

  handleActionClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: string,
  ) => {
    this.userManagementStore.setAnchorEl(event.currentTarget);
    this.userManagementStore.setActiveRowId(rowId);
  };

  handleOpenModal = (prefillUser?: Partial<UserFormSchema>) => {
    const store = this.userManagementStore;
    store.setEditModalOpen(false);
    store.setSelectedUser(undefined);
    store.setSelectedUserId(undefined);
    store.setCurrentStep(0);
    store.setPendingCreateUser(prefillUser);
    store.setAddModal(true);
  };
  handleCloseModal = () => {
    const store = this.userManagementStore;
    store.setAddModal(false);
    store.setEditModalOpen(false);
    store.setSelectedUser(undefined);
    store.setSelectedUserId(undefined);
    store.setPendingCreateUser(undefined);
    store.setCurrentStep(0);
  };
  handleOpenUserInvModal = () => {
    this.useUserInvStore.setModal(true);
  };

  handleChangeFacilityAdmin = () => {
    this.useUserInvStore.setModal(true);
    this.userManagementStore.setChangingAdmin(true);
  };

  handleCloseUserInvModal = (reset: UseFormReset<UserSchema>) => {
    this.useUserInvStore.setModal(false);
    this.useUserInvStore.setModalType(ModalType.QueryForm);
    this.useUserInvStore.setSelectedUser(undefined);
    this.useUserInvStore.setCurrentStep(0);
    reset(initialUserData);
  };

  handleSetEditMode = (user: string) => {
    const store = this.userManagementStore;
    store.setAddModal(false);
    store.setSelectedUser(undefined);
    store.setSelectedUserId(user);
    store.setEditModalOpen(true);
  };

  handleSetEditModeGroupAdmin = (user: string) => {
    const store = this.userManagementStore;
    store.setSelectedUserId(user);
    store.setIsEditGroupAdminModal(true);
  };

  handleCloseGroupModal = () => {
    const store = this.userManagementStore;
    store.setAddGroupAdminModal(false);
    store.setIsEditGroupAdminModal(false);
    store.setSelectedUserId("");
    store.setSelectedGroupClientIds([]);
  };

  handleContinue = () => {
    const store = this.userManagementStore;
    const userFormStore = this.useUserInvStore;
    store.setAddGroupAdminModal(false);
    store.setIsEditGroupAdminModal(false);
    userFormStore.setModal(true);
  };

  handleContinueEdit = () => {
    const store = this.userManagementStore;
    store.setEditModalOpen(true);
  };

  handleCloseConfirmPassModal = () => {
    this.userManagementStore.setConfirmPassModal(false);
  };

  handleCloseResetPassModal = () => {
    this.userManagementStore.setResetPassModal(false);
  };

  handleOpenConfirmPassModal = () => {
    this.userManagementStore.setConfirmPassModal(true);
  };

  handleOpenResetPassModal = () => {
    this.userManagementStore.setResetPassModal(true);
  };

  handleOpenLockUserModal = () => {
    this.userManagementStore.setLockUserModal(true);
  };

  handleCloseLockUserModal = () => {
    this.userManagementStore.setLockUserModal(false);
  };

  handleOpenDeleteUserModal = () => {
    this.userManagementStore.setDeleteUserModal(true);
  };

  handleCloseDeleteUserModal = () => {
    this.userManagementStore.setDeleteUserModal(false);
  };

  handleCloseCredentialsSent = () => {
    this.userManagementStore.setSelectedUser(undefined);
    this.userManagementStore.setUserCredentialsSentModal(false);
    this.userManagementStore.setActiveUser(undefined);
  };
}
